// JIRA LPPLWEBMOB-495
export enum ComponentId {
  APPLICANT_IS_OWNER = "ApplicantIsOwner",
  NAME = "name",
  SURNAME = "surname",
  PESEL = "pesel",
  PERSON_DATA_LACK_OF_PESEL = "lackOfPesel",
  PHONE = "phone",
  EMAIL = "email",
  STREET = "street",
  STREET_2 = "street2",
  ZIP_CODE_PL = "zipCodePL",
  ZIP_CODE_GENERIC = "zipCodeGeneric",
  CITY = "city",
  COUNTRY = "country",
  PROVINCE = "province",
  COOWNER = "coowner",
}
